import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useToasts } from 'react-toast-notifications'

const UserRoute = ({ loggedIn }: any) => {
  const { addToast } = useToasts()
  const token = sessionStorage.getItem('UserId')

  if (loggedIn) {
    return <Outlet />
  } else if (token) {
    return <Outlet />
  } else {
    return (
      <>
        {addToast('Access denied! Please login', {
          appearance: 'warning',
          autoDismiss: true,
        })}
        <Navigate to='/login' />
      </>
    )
  }
}
export default UserRoute
